export const suggestions = [
   { id: 1, value: "Garry Taylor" },
   { id: 2, value: "Kurth Guntheroth" },
   { id: 2, value: "Algorithms" },
   { id: 2, value: "User Experience" },
   { id: 2, value: "Alan Mellor" },
   { id: 2, value: "Elizabeth Simmons" },
   { id: 2, value: "Angela Yu" },
   { id: 2, value: "Patrik Sjölan" },
   { id: 2, value: "Tim Mensch" },
   { id: 2, value: "The Programming Hub" }
 ];